import distanceCorrelation from "../Data/distance_correlation.json";

export const array: {
	key_1: string;
	array2: { key_2: string; val_2: number }[];
}[] = [];

Object.entries(distanceCorrelation).forEach(([key_1, val_1]) => {
	const array2: { key_2: string; val_2: number }[] = [];
	Object.entries(val_1).forEach(([key_2, val_2]) => {
		array2.push({
			key_2: key_2,
			val_2: val_2,
		});
	});

	array.push({
		key_1: key_1,
		array2: array2,
	});
});
